import * as Yup from "yup";

export const validationSchema = (withCompanySelect: boolean) =>
  Yup.object({
    name: Yup.string().required("Portfolio name is required"),
    companyId: withCompanySelect ? Yup.string().required("Company is required") : Yup.string().notRequired(),
    description: Yup.string(),
    city: Yup.string().required("City is required"),
    area: Yup.string().required("Area is required"),
    buildingName: Yup.string().notRequired(),
    unitNumber: Yup.string().required("Unit number is required"),
    street: Yup.string().notRequired(),
    managerId: Yup.string().required("Portfolio manager is required"),
    images: Yup.array(),
  });
